import { useEffect } from 'react';
import { useTranslation } from '../i18n/useTranslation';

const DynamicMetaTags = () => {
  const { locale } = useTranslation();

  useEffect(() => {
    // Use single PNG for all languages
    const ogImage = 'https://busagent.org/open-g.png';

    // Update og:image
    let ogImageTag = document.querySelector('meta[property="og:image"]');
    if (ogImageTag) {
      ogImageTag.setAttribute('content', ogImage);
    }

    // Update twitter:image
    let twitterImageTag = document.querySelector('meta[name="twitter:image"]');
    if (twitterImageTag) {
      twitterImageTag.setAttribute('content', ogImage);
    }

    // Update og:locale
    let ogLocaleTag = document.querySelector('meta[property="og:locale"]');
    if (ogLocaleTag) {
      const localeValue = locale === 'en' ? 'en_US' : 'de_DE';
      ogLocaleTag.setAttribute('content', localeValue);
    }

    // Update html lang attribute
    document.documentElement.setAttribute('lang', locale);

    // Update content-language meta tag
    let contentLangTag = document.querySelector('meta[http-equiv="content-language"]');
    if (contentLangTag) {
      contentLangTag.setAttribute('content', locale);
    }

    // Update manifest link dynamically based on language
    let manifestLink = document.querySelector('link[rel="manifest"]');
    if (manifestLink) {
      const manifestPath = locale === 'en' ? '/manifest-en.json' : '/manifest.json';
      manifestLink.setAttribute('href', manifestPath);
    }

    // Update og:title and og:description based on language
    let ogTitleTag = document.querySelector('meta[property="og:title"]');
    let ogDescTag = document.querySelector('meta[property="og:description"]');
    let twitterTitleTag = document.querySelector('meta[name="twitter:title"]');
    let twitterDescTag = document.querySelector('meta[name="twitter:description"]');

    if (locale === 'en') {
      // English titles and descriptions
      if (ogTitleTag) {
        ogTitleTag.setAttribute('content', 'BusAgent - AI-Powered Public Transport Dispatch Software');
      }
      if (ogDescTag) {
        ogDescTag.setAttribute('content', 'Revolutionize your public transport with intelligent dispatching, automated scheduling, and real-time vehicle management. Trusted by 85+ cities worldwide.');
      }
      if (twitterTitleTag) {
        twitterTitleTag.setAttribute('content', 'BusAgent - AI-Powered Public Transport Dispatch Software');
      }
      if (twitterDescTag) {
        twitterDescTag.setAttribute('content', 'Intelligent dispatching, automated scheduling & real-time vehicle management for public transport. 300,000+ trips/month, 35% cost savings.');
      }
    } else {
      // German titles and descriptions (default)
      if (ogTitleTag) {
        ogTitleTag.setAttribute('content', 'BusAgent - KI-gestützte ÖPNV-Dispositionssoftware');
      }
      if (ogDescTag) {
        ogDescTag.setAttribute('content', 'Revolutionieren Sie Ihren ÖPNV mit intelligenter Disposition, automatisierter Dienstplanung und Echtzeit-Fahrzeugmanagement. Vertrauen von 85+ Städten weltweit.');
      }
      if (twitterTitleTag) {
        twitterTitleTag.setAttribute('content', 'BusAgent - KI-gestützte ÖPNV-Dispositionssoftware');
      }
      if (twitterDescTag) {
        twitterDescTag.setAttribute('content', 'Intelligente Disposition, automatisierte Dienstplanung & Echtzeit-Fahrzeugmanagement für den ÖPNV. 300.000+ Fahrten/Monat, 35% Kosteneinsparung.');
      }
    }

  }, [locale]);

  return null; // This component doesn't render anything
};

export default DynamicMetaTags;
